<template>
  <div class="pre__modal" @click="close" v-show="visible">
    <img :src="src" class="pre_img" />
  </div>
</template>

<script>
export default {
  data() {
    return { src: '', visible: false }
  },
  methods: {
    show (data) {
      this.src = data
      this.visible = true
    },
    close() {
      this.visible = false
    }
  }
}
</script>

<style>
.pre__modal {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pre_img {
  max-height: 100%;
  max-width: 90%;
  min-width: 650px;
  cursor: pointer;
}
</style>
